import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { CreateTurnoCampaniaEncuestaRespuestaCommand } from '../../model/campania-encuesta/campania-encuesta';

@Injectable({
  providedIn: 'root',
})
export class TurnoCampaniaEncuestaRespuestaService {
  private readonly endPoint = '/TurnoCampaniaEncuestaRespuesta';

  constructor(private dataService: DataService) {}

  async create(command: CreateTurnoCampaniaEncuestaRespuestaCommand): Promise<void> {
    await this.dataService
      .post<void>(`${this.endPoint}/create`, command)
      .toPromise();
  }
}
